module.exports = __webpack_public_path__ + "static/media/2.0f82f8a5.png";